import styled from 'styled-components'
import { Modal } from '@carbon/react'
import { gray100 } from '@carbon/colors'

export const Root = styled(Modal)`
  .cds--modal-container {
    background-color: ${gray100};
  }
`